import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { UPDATE_ENTRY_STRATEGY } from './actionTypes';
import { updateEntryStrategySuccess, updateEntryStrategyFailure } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

// Is user register successfull then direct plot user in redux.
function* updateEntryStrategy({ payload: { token, id, name, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.updateEntryStrategy, { token, id, name });
    yield put(updateEntryStrategySuccess(response));
    //history.go();
  } catch (error) {
    yield put(updateEntryStrategyFailure(error));
  }
}

export function* watchEntryStrategyUpdate() {
  yield takeEvery(UPDATE_ENTRY_STRATEGY, updateEntryStrategy);
}

function* updateEntryStrategySaga() {
  yield all([fork(watchEntryStrategyUpdate)]);
}

export default updateEntryStrategySaga;
